import React from 'react';

export default () => {
  return (
    <div>
      <h1 className="display-4">About Tasks Manager</h1>
      <p className="lead">Simple app to manage tasks</p>
      <p className="text-secondary">Version 1.0.0</p>
    </div>
  );
};
